export default
{
	TEXT: 'text',
	TIME: 'time'
};